import React from "react";
import PropTypes from "prop-types";
import styles from "./StandingOrderRadioButton.module.css";
import StandingOrderIcon from "../StandingOrderIcon";
import classNames from "classnames";

/**
 * Interactive component. A radio button styled as an icon tile for a Standing Order feed item.
 */

export function StandingOrderRadioButton({
  iconType,
  isChecked,
  setCurrentChecked,
}) {
  const handleChange = (event) => {
    setCurrentChecked(event.target.value);
  };

  return (
    <div className={styles.container}>
      <label htmlFor={iconType}>
        <input
          value={iconType}
          name="standing-order"
          type="radio"
          hidden
          checked={isChecked}
          onChange={handleChange}
        />

        <button
          onClick={setCurrentChecked}
          type="button"
          title={iconType}
          className={classNames(styles.button, {
            [styles.active]: isChecked,
          })}
        >
          <StandingOrderIcon iconType={iconType} iconSize="50px" />
        </button>
      </label>
    </div>
  );
}

StandingOrderRadioButton.propTypes = {
  /**
   * String that determines the icon appearance.
   */
  iconType: PropTypes.oneOf([
    "DR",
    "DS",
    "DN",
    "ER",
    "FR",
    "FMA",
    "FE",
    "SP",
    "SL",
    "3P",
    "Compass",
  ]),
  /**
   * Boolean that determines if the radio button is checked.
   */
  isChecked: PropTypes.bool,
  /**
   * Function that fires when the radio button is clicked.
   */
  setCurrentChecked: PropTypes.func,
};
